export default "__VITE_ASSET__CAMsl0YU__"